const routes = {
  "app.ces.getCesInfo": "api/app/ces",
  "app.drivingLicense.getDrivingLicense": "api/app/driving-license",
  "app.familyStatus.getCertificate": "api/app/family-status-get-certificate",
  "app.familyStatus.getFamilyStatusData": "api/app/family-status",
  "app.incomeTax.getIncomeTax": "api/app/income-tax",
  "app.job.getJobInfo": "api/app/job",
  "app.notary.getNotaryInfo": "api/app/notary",
  "app.notifications.list": "api/app/notifications",
  "app.notifications.markAsRead": "api/app/notifications/{guid}/read",
  "app.notificationSettings.defaultInfo": "api/app/notification-settings/default-info",
  "app.notificationSettings.addPhone": "api/app/notification-settings/phone",
  "app.notificationSettings.resendPhone": "api/app/notification-settings/phone/resend",
  "app.notificationSettings.verifyPhone": "api/app/notification-settings/phone/verify",
  "app.notificationSettings.deletePhone": "api/app/notification-settings/phone/{id}",
  "app.notificationSettings.addEmail": "api/app/notification-settings/email",
  "app.notificationSettings.resendEmail": "api/app/notification-settings/email/resend",
  "app.notificationSettings.verifyEmail": "api/app/notification-settings/email/verify",
  "app.notificationSettings.deleteEmail": "api/app/notification-settings/email/{id}",
  "app.organizations.getOrganizations": "api/app/organizations",
  "app.organizations.getTaxRegistrationDetails": "api/app/organizations/tax-details",
  "app.passport.getPassportInfo": "api/app/passports",
  "app.pension.getPensionInfo": "api/app/pension",
  // "app.qr.confirmCodeGetQr": "api/app/confirm-code",
  // "app.qr.sendCode": "api/app/send-code",
  "auth.qr.login": "api/auth/qr-login",
  "app.realEstate.checkPayment": "api/app/check-payment",
  "app.realEstate.getRealEstate": "api/app/real-estate",
  "app.regionStatistic.getRegionStatistic": "api/region-statistic",
  "app.registrationAddresses.getRegistrationAddresses": "api/app/registration-address",
  "app.requests.getRequests": "api/app/requests-history",
  "app.school.getSchoolInfo": "api/app/school",
  "app.searchKeywords.getKeywords": "api/app/search-keywords",
  "app.socialInfo.getSocialInfo": "api/app/social-status",
  "app.sso.uensHandoff": "api/app/sso/uens-handoff",
  "app.vehicle.getVehicle": "api/app/movable-estate",
  "app.violations.getViolations": "api/app/violations",
  "app.weapons.getWeapons": "api/app/weapons",
  "auth.nid.handle.callback": "api/auth/signing/nid/handle/callback",
  "auth.pin.change": "api/auth/pin/change",
  "auth.pin.delete": "api/auth/pin/delete",
  "auth.pin.hasPin": "api/auth/pin/has-pin",
  "auth.pin.set": "api/auth/pin/set",
  "auth.pin.verify": "api/auth/pin/verify",
  "auth.qrcode.verify": "api/auth/qr-code/verify",
  "auth.session.currentSession": "api/auth/session/current",
  "auth.session.getActiveSessions": "api/auth/session/active-sessions",
  "auth.session.heartbeat": "api/auth/session/heartbeat",
  "auth.session.terminate": "api/auth/session/terminate-session",
  "auth.session.terminateAll": "api/auth/session/terminate-all-sessions",
  "auth.signing.signIn": "api/auth/signing/sign-in",
  "auth.signing.signOut": "api/auth/signing/sign-out",
  nid_callback: "api/auth/nid/callback",
  "pdf.notify.createPdf": "api/pdf/create",
};

export default routes;
